import { withStyles } from "@material-ui/core/styles"
import Tooltip from "@material-ui/core/Tooltip"

const TooltipPersonalizado = withStyles((theme) => ({
	tooltip: {
		border: "1px solid #C0C0DE",
		borderRadius: "3px",
		backgroundColor: "#ECECF5",
		boxShadow: "0 5px 10px 0 rgba(192, 192, 222, 0.43)",
		color: " #23144D",
		fontFamily: "CircularStd-Book",
		fontSize: "14px",
		left: "-50px"
	},
}))(Tooltip)

export default TooltipPersonalizado
